import { FunctionFactory } from 'survey-core';
import { CalorieTracking } from '../quiz/calories';
import { Goals } from '../quiz/goals';
import { tSurvey } from '../i18n/survey';
import { makeSplashHeader } from './SplashHeader';

const calorieSplashHtml = `
<div class="new-quote-container centered">
  <div class="splash-icon">{calorieIcon}</div>
  <div class="splash-header">
    <h1>{calorieTitle}</h1>
    <div class="quote">
      {calorieQuote}
    </div>
  </div>
</div> 
`;

const calorieSplashExpression = {
  name: "calorieQuote",
  expression: "renderCalorieQuote({calories}, {goals})",
};

function calorieGoalKey(goals: Goals): string | undefined {
  switch (goals) {
    case Goals.LoseFat:
      return "loseWeight";
    case Goals.BuildMuscle:
      return "buildMuscle";
    case Goals.BuildMuscleAndLoseFat:
      return "recomp";
  }
}

// Whole sentence per (tracking answer, goal): Spanish wording changes around
// the goal, so the goal is not spliced into an English sentence frame.
function renderCalorieQuote(params: any[]): string {
  if (params === undefined || params === null) return "";
  const goalKey = calorieGoalKey(params[1] as Goals);
  switch (params[0] as CalorieTracking) {
    case CalorieTracking.NoIdea:
      return goalKey ? tSurvey(`splash.calorie.quote.noIdea.${goalKey}`) : "";
    case CalorieTracking.EatingMore:
    case CalorieTracking.EatingLess:
      return goalKey ? tSurvey(`splash.calorie.quote.eating.${goalKey}`) : "";
    case CalorieTracking.PrettyClose: {
      return tSurvey("splash.calorie.quote.prettyClose");
    }
  }
}

FunctionFactory.Instance.register("renderCalorieQuote", renderCalorieQuote);

const calorieSplashElement = {
  name: 'calorie-splash',
  type: 'html',
  html: calorieSplashHtml,
}

function renderCalorieTitle(params: any[]): string {
  if (params === undefined || params === null) return "";
  switch (params[0] as CalorieTracking) {
    case CalorieTracking.NoIdea:
      return tSurvey("splash.calorie.title.noIdea");
    case CalorieTracking.EatingMore:
    case CalorieTracking.EatingLess:
      return tSurvey("splash.calorie.title.eating");
    case CalorieTracking.PrettyClose:
      return tSurvey("splash.calorie.title.prettyClose");
  }
}

const calorieSplashTitleExpression = {
  name: "calorieTitle",
  expression: "renderCalorieTitle({calories})",
};

FunctionFactory.Instance.register("renderCalorieTitle", renderCalorieTitle);
  
function renderCalorieIcon(params: any[]): string {
  if (params === undefined || params === null) return "";
  switch (params[0] as CalorieTracking) {
    case CalorieTracking.NoIdea:
      return "👍";
    case CalorieTracking.EatingMore:
    case CalorieTracking.EatingLess:
      return "🎯";
    case CalorieTracking.PrettyClose:
      return "🔒";
  }
}

FunctionFactory.Instance.register("renderCalorieIcon", renderCalorieIcon);

const calorieSplashIconExpression = {
  name: "calorieIcon",
  expression: "renderCalorieIcon({calories})",
};
const CalorieSplashHeader = makeSplashHeader("splash.headers.calorie");

export {
  calorieSplashElement,
  calorieSplashExpression,
  CalorieSplashHeader,
  calorieSplashTitleExpression,
  calorieSplashIconExpression,
}